import { render, staticRenderFns } from "./OFormUserComp.vue?vue&type=template&id=2a445076&"
import script from "./OFormUserComp.vue?vue&type=script&lang=js&"
export * from "./OFormUserComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports